export default __webpack_public_path__ + "static/media/project-2.6ce85acb.jpg";